import { FormInput, FormLabel, Grid, Spacer, Text, FormTextarea, FormSelect, useDialog } from "@holta/ui";
import { deleteSupplierAndAddresses } from "../../../actions/editSupplier";
import React from "react";
import styled from "styled-components";
import {useMergedSupplier} from "../hooks/useMergedSupplierValues";

interface Props {
    children?: React.ReactNode;
}

export const Settings: React.FC<Props> = ({ children }) => {

    const {openGenericDialog} = useDialog();
    const customer = useMergedSupplier();

    if(!customer?.id) return null;

    return (
        <div>
            
            <Spacer xs={[2]}>
                <Text size="xl">Delete Supplier</Text>
                <Grid.Row>
                    <Grid.Col xs={{cols: 6}}>
                        <Spacer xs={[1, 1, 1, 0]}>
                            <button className="danger" onClick={() => {
                                openGenericDialog('Are you sure you want to permenantly delete this supplier and associated contacts and addresses?', 'Delete Supplier', false, true, () => deleteSupplierAndAddresses(customer.id as string), false)
                            }}>Delete</button>
                        </Spacer>
                    </Grid.Col>
                    
                </Grid.Row>
            </Spacer>
            
        </div>
    );
};
